<h1 class="text-center">{{ 'PD_COLLECT_DATA.HEADER.UPLOAD_FILES' | translate }}</h1>
<p class="text-center mb-4">{{ 'PD_COLLECT_DATA.TEXT.UPLOAD_FILES_DISCLAIMER' | translate }}</p>
<div class="mb-2" *ngIf="visibility.corporateCertificate">
  <app-pd-document-file (selectFile)="setCorporateCertificate($event)" (clearedFile)="clearCorporateCertificate()">
    {{ 'PD_COLLECT_DATA.LABEL.CORPORATE_CERTIFICATE' | translate }}
  </app-pd-document-file>
</div>
<div class="mb-2" *ngIf="visibility.accountOwnerId">
  <app-pd-document-file class="mb-4" (selectFile)="setAccountOwnerId($event)" (clearedFile)="clearAccountOwnerId()">
    {{ 'PD_COLLECT_DATA.LABEL.ACCOUNT_OWNER_ID_PHOTO' | translate }}
  </app-pd-document-file>
</div>
<div class="mb-2" *ngIf="visibility.bankAccountOwnership">
  <app-pd-document-file class="mb-4" (selectFile)="setBankAccountOwnership($event)" (clearedFile)="clearBankAccountOwnership()">
    {{ 'PD_COLLECT_DATA.LABEL.BANK_ACCOUNT_OWNERSHIP' | translate }}
  </app-pd-document-file>
</div>
<div class="mb-2" *ngIf="visibility.businessStamp">
  <app-pd-document-file class="mb-4" (selectFile)="setBusinessStamp($event)" (clearedFile)="clearBusinessStamp()">
    {{ 'PD_COLLECT_DATA.LABEL.BUSINESS_STAMP' | translate }}
  </app-pd-document-file>
</div>
<div class="mb-4">
  <span class="text-light text-sm">{{ 'PD_COLLECT_DATA.TEXT.SUPPORTED_TYPES' | translate }}</span>
</div>
<div class="mb-6">
  <label>*{{ 'PD_COLLECT_DATA.LABEL.SIGNATURE' | translate }}</label>
  <div class="my-2">
    <signature-pad
      (drawEnd)="setSignature()"
      [options]="signaturePadOptions"
      [ngStyle]="{ 'background-color': 'transparent' }"
    ></signature-pad>
  </div>
  <div class="flex justify-content-end">
    <button pButton pRipple class="p-button-rounded" (click)="clearSignature()">
      <i class="pi pi-refresh"></i>&nbsp;{{ 'PD_COLLECT_DATA.LABEL.CLEAR' | translate }}
    </button>
  </div>
</div>

<div class="flex justify-content-between">
  <button pButton pRipple (click)="goBack()" type="button" icon="pi pi-arrow-left" class="p-button-rounded"></button>
  <button pButton class="simple-button w-9" [disabled]="!valid" (click)="submit()">
    {{ 'PD_COLLECT_DATA.LABEL.CONTINUE' | translate }}
  </button>
</div>
